export const BRIEF_TITLE = 'БРИФ ДЛЯ ТАРГЕТОЛОГА';

export const BRIEF_STEPS = [
  {
    section: 'О бизнесе',
    title: 'Расскажите о своём бизнесе',
    hint: 'Таргетологу нужно понять контекст, чтобы правильно настроить рекламу с первого раза.',
  },
  {
    section: 'Целевая аудитория',
    title: 'Кто ваш клиент?',
    hint: 'Чем точнее описание, тем точнее настройка. Если есть несколько сегментов — опишите основной.',
  },
  {
    section: 'Опыт с рекламой',
    title: 'Что уже пробовали?',
    hint: 'Это помогает не повторять ошибки и сразу строить на том что работало.',
  },
  {
    section: 'Бюджет',
    title: 'Сколько готовы вложить?',
    hint: 'Указывайте только рекламный бюджет — деньги которые идут непосредственно в кабинет. Гонорар специалиста — отдельно.',
  },
  {
    section: 'Цели и KPI',
    title: 'Чего хотите достичь?',
    hint: 'Конкретные цифры лучше размытых пожеланий. Таргетолог сможет предложить реалистичный план.',
  },
  {
    section: 'Процесс работы',
    title: 'Как будем работать?',
    hint: 'Последний блок — помогает избежать недопонимания на старте.',
  },
];

export const BRIEF_FIELDS = {
  NAME: {
    label: 'Название компании / бренда',
    placeholder: 'Например: Студия красоты «Луна»',
    sublabel: '',
  },
  NICHE: {
    label: 'Сфера / ниша',
    placeholder: 'Например: салон красоты, стоматология, доставка еды',
    sublabel: '',
  },
  PRODUCT: {
    label: 'Что именно продаёте — опишите продукт или услугу',
    placeholder:
      'Например: маникюр и педикюр, средний чек 8 000–12 000 ₸. Работаем только с гель-лаком премиум-класса. Принимаем по записи.',
    sublabel: 'Чем конкретнее, тем лучше — включите ключевые характеристики и ценовой диапазон',
  },
  USP: {
    label: 'Ваше главное конкурентное преимущество',
    placeholder: 'Например: 10 лет опыта, работаем до 22:00, есть парковка, гарантия покрытия 3 недели...',
    sublabel: 'Почему клиент должен выбрать именно вас?',
  },
  URL: {
    label: 'Ссылка на сайт или Instagram',
    placeholder: 'https://',
    sublabel: '',
  },
  CITY: {
    label: 'Город / география работы',
    placeholder: 'Например: Алматы, только Бостандыкский район',
    sublabel: '',
  },
  AGE: {
    label: 'Возраст',
    placeholder: 'Например: 25–40 лет',
    sublabel: '',
  },
  INTERESTS: {
    label: 'Интересы и образ жизни клиента',
    placeholder:
      'Например: следит за модой, активно пользуется Instagram, ходит в фитнес, ценит качество и время, работает в офисе или сама руководит...',
    sublabel: 'Чем увлекается, что читает, где бывает — чем больше деталей, тем лучше',
  },
  PAIN: {
    label: 'Главная боль или проблема клиента',
    placeholder:
      'Например: не может найти мастера в удобное время, устала от некачественного покрытия, хочет сделать красиво но без переплаты...',
    sublabel: 'Что заставляет его искать ваш продукт?',
  },
  TRIGGERS: {
    label: 'Что мотивирует к покупке — триггеры',
    placeholder:
      'Например: предстоящее мероприятие, устала от текущего мастера, увидела красивый маникюр у подруги, скидка...',
    sublabel: 'Какой повод заставляет клиента искать вас прямо сейчас?',
  },
  OBJECTIONS: {
    label: 'Главные возражения — почему могут не купить',
    placeholder: 'Например: дорого, не доверяю новому мастеру, далеко ехать, нет отзывов...',
    sublabel: '',
  },
  WORKED: {
    label: 'Что работало хорошо',
    placeholder:
      'Например: видео-reels давали дешёвые заявки, лид-формы в Instagram конвертировали лучше сайта...',
    sublabel: '',
  },
  FAILED: {
    label: 'Что не работало или разочаровало',
    placeholder:
      'Например: клики были, но заявок почти нет, дорогая стоимость заявки, нецелевая аудитория...',
    sublabel: '',
  },
  MAX_CPL: {
    label: 'Есть ли максимально допустимая стоимость заявки (CPL)?',
    placeholder: 'Например: не более 3 000 ₸ за заявку',
    sublabel: 'Если считали по CPL-калькулятору — укажите вашу красную линию',
  },
  MONTHLY_TARGET: {
    label: 'Сколько клиентов / заявок нужно в месяц',
    placeholder: 'Например: 30 заявок в месяц или 20 новых клиентов',
    sublabel: '',
  },
  CONTACT: {
    label: 'Кто со стороны клиента ведёт коммуникацию и согласовывает',
    placeholder: 'Имя и должность, например: Аида, владелец / Марат, маркетолог',
    sublabel: '',
  },
  EXTRA: {
    label: 'Дополнительные пожелания или важная информация',
    placeholder:
      'Например: не упоминать конкурентов по имени, нет рекламы алкоголя, важно не снижать цену, есть сезонность — пик в декабре...',
    sublabel: 'Всё что не вошло выше — конкуренты, ограничения, особые требования',
  },
};

export const BRIEF_GROUP_LABELS = {
  GENDER: 'Пол',
  EXPERIENCE: 'Запускали рекламу раньше?',
  PLATFORMS: 'Какие платформы использовали',
  PIXEL: 'Есть ли настроенный пиксель / аналитика?',
  BUDGET: 'Ежемесячный рекламный бюджет',
  SCALE: 'Готовы ли увеличить бюджет если реклама даёт результат?',
  CREATIVE: 'Есть ли бюджет на создание креативов (фото / видео / дизайн)?',
  GOAL: 'Желаемая чистая прибыль в месяц',
  KPIS: 'По каким показателям будете оценивать работу таргетолога',
  DEADLINE: 'Срок — когда нужен первый результат',
  MESSENGER: 'Предпочтительный мессенджер для связи',
  MATERIALS: 'Есть ли готовые материалы для рекламы?',
  LANDING: 'Посадочная страница — куда будет вести реклама',
};

export const OPTION_LABELS = {
  OPTION_GENDER_F: 'Женщины',
  OPTION_GENDER_M: 'Мужчины',
  OPTION_GENDER_ALL: 'Все',
  OPTION_EXP_NO: 'Нет, запускаем впервые',
  OPTION_EXP_YES: 'Да, есть опыт',
  PLATFORM_IG: 'Instagram',
  PLATFORM_TT: 'TikTok',
  PLATFORM_YT: 'YouTube',
  PLATFORM_VK: 'ВКонтакте',
  PLATFORM_GG: 'Google',
  PLATFORM_YD: 'Яндекс',
  OPTION_PIXEL_YES: 'Да, настроен',
  OPTION_PIXEL_NO: 'Нет',
  OPTION_PIXEL_UNKNOWN: 'Не знаю',
  OPTION_BUDGET_LOW: 'До 50 000 ₸',
  OPTION_BUDGET_MID: '50 000 – 150 000 ₸',
  OPTION_BUDGET_MID_HIGH: '150 000 – 300 000 ₸',
  OPTION_BUDGET_HIGH: '300 000 – 500 000 ₸',
  OPTION_BUDGET_TOP: 'Более 500 000 ₸',
  OPTION_SCALE_YES: 'Да, готовы масштабировать',
  OPTION_SCALE_NO: 'Нет, фиксированный бюджет',
  OPTION_SCALE_MAYBE: 'Возможно, по ситуации',
  OPTION_CREATIVE_YES: 'Да, есть отдельный бюджет',
  OPTION_CREATIVE_NO: 'Нет, нужно использовать готовые материалы',
  OPTION_CREATIVE_DISCUSS: 'Обсудим отдельно',
  OPTION_GOAL_LEADS: 'Заявки и звонки',
  OPTION_GOAL_SALES: 'Продажи на сайте',
  OPTION_GOAL_SUBS: 'Подписчики в Instagram',
  OPTION_GOAL_BRAND: 'Узнаваемость бренда',
  OPTION_GOAL_VISIT: 'Посетители в офлайн-точку',
  KPI_CPL: 'Стоимость заявки (CPL)',
  KPI_LEADS: 'Количество заявок',
  KPI_ROMI: 'ROMI',
  KPI_SALES: 'Продажи',
  KPI_REACH: 'Охваты',
  KPI_SUBS: 'Подписчики',
  OPTION_DEADLINE_2W: 'В течение 2 недель',
  OPTION_DEADLINE_1M: 'В течение месяца',
  OPTION_DEADLINE_3M: '2–3 месяца, готовы ждать',
  OPTION_DEADLINE_NONE: 'Нет жёстких сроков',
  OPTION_MESSENGER_WA: 'WhatsApp',
  OPTION_MESSENGER_TG: 'Telegram',
  OPTION_MESSENGER_IG: 'Instagram DM',
  OPTION_MESSENGER_EMAIL: 'Email',
  MAT_PHOTO: 'Фотографии',
  MAT_VIDEO: 'Видео',
  MAT_BRAND: 'Логотип и фирменный стиль',
  MAT_TEXT: 'Готовые тексты',
  MAT_NONE: 'Нет, нужно создавать с нуля',
  OPTION_LANDING_SITE: 'Сайт / лендинг',
  OPTION_LANDING_IG: 'Instagram профиль',
  OPTION_LANDING_FORM: 'Лид-форма в рекламном кабинете',
  OPTION_LANDING_WA: 'WhatsApp / мессенджер',
  OPTION_LANDING_NEW: 'Нужно создать посадочную',
};

export const OPTION_PILL_LABELS = {
  OPTION_EXP_NO: 'Нет, впервые',
  OPTION_PIXEL_YES: 'Да',
  OPTION_BUDGET_MID: '50–150 тыс ₸',
  OPTION_BUDGET_MID_HIGH: '150–300 тыс ₸',
  OPTION_BUDGET_HIGH: '300–500 тыс ₸',
  OPTION_BUDGET_TOP: 'Более 500 тыс ₸',
  OPTION_SCALE_YES: 'Да',
  OPTION_SCALE_NO: 'Нет, фиксированный',
  OPTION_SCALE_MAYBE: 'По ситуации',
  OPTION_CREATIVE_YES: 'Да',
  OPTION_CREATIVE_NO: 'Нет',
  OPTION_CREATIVE_DISCUSS: 'Обсудим',
  OPTION_GOAL_SUBS: 'Подписчики',
  OPTION_GOAL_BRAND: 'Узнаваемость',
  OPTION_GOAL_VISIT: 'Трафик в точку',
  KPI_CPL: 'CPL',
  KPI_LEADS: 'Кол-во заявок',
  OPTION_DEADLINE_2W: '2 недели',
  OPTION_DEADLINE_1M: '1 месяц',
  OPTION_DEADLINE_3M: '2–3 месяца',
  OPTION_DEADLINE_NONE: 'Без срока',
  OPTION_MESSENGER_IG: 'Instagram',
  MAT_PHOTO: 'Фото',
  MAT_BRAND: 'Логотип/стиль',
  MAT_TEXT: 'Тексты',
  MAT_NONE: 'Нет, с нуля',
  OPTION_LANDING_SITE: 'Сайт',
  OPTION_LANDING_IG: 'Instagram',
  OPTION_LANDING_FORM: 'Лид-форма',
  OPTION_LANDING_WA: 'WhatsApp',
  OPTION_LANDING_NEW: 'Создать',
};

export const getOptionLabel = (id) => OPTION_LABELS[id] || id;

export const getOptionPillLabel = (id) => OPTION_PILL_LABELS[id] || OPTION_LABELS[id] || id;
